const flags = Object.entries(process.env)
const enabledFeatures = flags
    .filter(([key]) => key.startsWith('REACT_APP_ENABLE_'))
    .reduce((acc, [key, value]) => {
        const featureKey = key.replace(/^REACT_APP_ENABLE_/, '')
        acc[featureKey] = value === 'true' || value === true
        return acc
    }, {})

export const FEATURES = Object.keys(enabledFeatures).reduce((acc, key) => {
    acc[key] = key
    return acc
}, {})

export default function isFeatureEnabled(featureName) {
    return enabledFeatures[featureName]
}
